import { render } from "./cockpitTree.vue?vue&type=template&id=36fe3db7&scoped=true"
import script from "./cockpitTree.vue?vue&type=script&lang=js"
export * from "./cockpitTree.vue?vue&type=script&lang=js"

import "./cockpitTree.vue?vue&type=style&index=0&id=36fe3db7&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36fe3db7"]])

export default __exports__